import { cn } from '../../lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'rectangular' | 'circular';
}

function Skeleton({ className, variant = 'text', ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-muted',
        {
          'h-4 w-full': variant === 'text',
          'h-10 w-full': variant === 'rectangular',
          'h-10 w-10 rounded-full': variant === 'circular',
        },
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
